import {forward, guard, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';

import {tableStateChanged} from '../table';

import {
    data$,
    dataChanged,
    dataSubmitted,
    editGtinApiV2Fx,
    formData$,
    formDataChanged,
    formDataReset,
    isFormModalOpen$,
    isFormModalOpenChanged,
    isModalOpen$,
    isModalOpenChanged,
    uploadDataApiV2Fx,
    isRecallModalOpen$,
    isRecallModalOpenChanged,
    recallGtinFx,
    isRecallFailed$,
    isRecallFailedChanged,
    deleteGtinApiV2Fx,
} from './index';

data$.on(dataChanged, (_, payload) => payload).reset(uploadDataApiV2Fx.done);
isModalOpen$.on(isModalOpenChanged, (_, payload) => payload).reset(uploadDataApiV2Fx.done);

formData$
    .on(formDataChanged, (_, payload) => payload)
    .on(editGtinApiV2Fx.doneData, (_, result) => [result])
    .reset(formDataReset);
isFormModalOpen$.on(isFormModalOpenChanged, (_, payload) => payload);
isRecallModalOpen$.on(isRecallModalOpenChanged, (_, payload) => payload);
uploadDataApiV2Fx.fail.watch(({error}) => showRestError(error as RestError));
uploadDataApiV2Fx.done.watch(() => {
    isFormModalOpenChanged(false);
    isModalOpenChanged(false);
    toast.success(i18next.t('pages.registries.uploadSuccess'));
});

recallGtinFx.fail.watch(({error}) => showRestError(error as RestError));
recallGtinFx.done.watch(() => {
    isRecallModalOpenChanged(false);
    toast.success(i18next.t('pages.registries.recallSuccess'));
});

editGtinApiV2Fx.fail.watch(({error}) => showRestError(error as RestError));

deleteGtinApiV2Fx.fail.watch(({error}) => showRestError(error as RestError));
deleteGtinApiV2Fx.done.watch(() => {
    isFormModalOpenChanged(false);
    toast.success(i18next.t('pages.registries.deleteSuccess'));
});

isRecallFailed$
    .on(isRecallFailedChanged, (_, payload) => payload)
    .on(recallGtinFx.fail, () => true)
    .on(recallGtinFx.done, () => false)
    .on(recallGtinFx, () => false);

sample({
    clock: dataSubmitted,
    source: data$,
    fn: (data) => data || [],
    target: uploadDataApiV2Fx,
});

forward({
    from: [uploadDataApiV2Fx.doneData, recallGtinFx.doneData, deleteGtinApiV2Fx.doneData],
    to: tableStateChanged,
});

guard({
    source: isFormModalOpenChanged,
    filter: (isOpen) => !!isOpen,
    target: formDataReset,
});
